import { render, staticRenderFns } from "./SettlementSelectInputWidget.vue?vue&type=template&id=50e22b44&scoped=true"
import script from "./SettlementSelectInputWidget.vue?vue&type=script&lang=js"
export * from "./SettlementSelectInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e22b44",
  null
  
)

export default component.exports